{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "आप एजेंट लिमिट पार कर चुके है।आपका प्लान {allowedAgents} एजेंट्स की अनुमति देता है।",
      "NON_ADMIN": "कृपया प्लान को अपग्रेड करने और सभी सुविधाओं का उपयोग जारी रखने के लिए अपने व्यवस्थापक से संपर्क करें।"
    },
    "TITLE": "Account settings",
    "SUBMIT": "Update settings",
    "BACK": "Back",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Could not update settings, try again!",
      "SUCCESS": "Successfully updated account settings"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "अपना खाता हटाएं",
      "NOTE": "एक बार जब आप अपना खाता हटा देंगे, तो आपका सारा डेटा हटा दिया जाएगा।",
      "BUTTON_TEXT": "अपना खाता हटाएं",
      "CONFIRM": {
        "TITLE": "खाता हटाएं",
        "MESSAGE": "आपका खाता हटाना अपरिवर्तनीय है। नीचे अपने खाते का नाम दर्ज करे ये पुष्टि करने के लिए की आप इसे निरंतर रूप से ख़त्म करना चाहते है।",
        "BUTTON_TEXT": "Delete",
        "DISMISS": "Cancel",
        "PLACE_HOLDER": "Please type {accountName} to confirm"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Please fix form errors",
      "GENERAL_SECTION": {
        "TITLE": "General settings",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferences",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Account name",
        "PLACEHOLDER": "Your account name",
        "ERROR": "Please enter a valid account name"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Your account name",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "The domain where you will receive the emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support Email",
        "PLACEHOLDER": "Your company's support email",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Update",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Conversation continuity with emails is enabled for your account.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "You can receive emails in your custom domain now."
      }
    },
    "UPDATE_CHATWOOT": "An update {latestChatwootVersion} for Chatwoot is available. Please update your instance.",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Your payment is pending. Please update your payment information to continue using Chatwoot",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "Your account has exceeded the usage limits, please upgrade your plan to continue using Chatwoot",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Press enter to select",
      "ENTER_TO_REMOVE": "Press enter to remove",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Select one",
      "SELECT": "Select"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Mark All Done",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Loading notifications...",
      "404": "No Notifications",
      "TABLE_HEADER": [
        "Name",
        "Phone Number",
        "Conversations",
        "Last Contacted"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "New conversation",
      "conversation_assignment": "Conversation Assigned",
      "assigned_conversation_new_message": "New Message",
      "participating_conversation_new_message": "New Message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Reports",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Settings",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click here"
  }
}
